import React, { useState, useEffect } from 'react';
import { Activity, Drum, BedDouble, CalendarDays, User, ChevronLeft, ChevronRight, UserMinus2 } from 'lucide-react';
import './UsersPage.css';
import {Card, CardContent, StatCard} from "../../components/card-components";
import DashboardBase  from "../DashboardBase";
import {Loader} from "../../components/loader";
import { useNavigate } from "react-router";
import {ROLES} from "../../config/routes";

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("GBP");
  const [loading, setLoading] = useState({
    users: true,
    stats: true,
  });
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  
  useEffect(() => {
    // Fetch the transaction data from the backend
    fetchTransactions(currentPage);
  }, [currentPage]);

  useEffect(() => {
    // Fetch the transaction data from the backend
    fetchStats(selectedCurrency);
  }, [selectedCurrency]);

  const fetchStats = (target_currency) => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate(`/login`);
    }
    let url = `${process.env.REACT_APP_API_URL}/api/v1/analytics/${target_currency}/user-metrics`;
    fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setStats(data.metrics);
        setLoading(prev => ({ ...prev, stats: false }));
      })
      .catch((error) => {
        setError(error);
        setLoading(prev => ({ ...prev, stats: false }));
      });
  };

  const fetchTransactions = (page) => {
    const token = localStorage.getItem('token');
    const indexOfLastTransaction = ((page - 1) * itemsPerPage);
    
    fetch(`${process.env.REACT_APP_API_URL}/api/v1/users?offset=${indexOfLastTransaction}&limit=${itemsPerPage}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setUsers(data.rows);
        setTotal(data.total);
        setLoading(prev => ({ ...prev, users: false }));
      })
      .catch((error) => {
        setError(error);
        setLoading(prev => ({ ...prev, users: false }));
      });
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'customer': return 'status-completed';
      case 'admin': return 'status-pending';
      case 'fund_manager': return 'status-rejected';
      default: return 'status-default';
    }
  };

  const goToItem = (id) => {
    navigate(`/user-details/${id}`);
  };

  const goToCreate = () => {
    navigate(`/create-user`);
  };

  const goToAssign = () => {
    navigate(`/assign-user`);
  };

  const isLoading = Object.values(loading).some(status => status);
  if (isLoading) {
    <Loader loading={isLoading} />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <DashboardBase
      page="users"
      content= {
            <div className="dashboard-home">
                {/* Secondary Navigation */}

                <div className="dashboard-header">
                        <h1>Summary</h1>
                        <div className="sidenote">
                        <button
                            onClick={() => goToAssign()}
                            type="button" 
                            className="button secondary">
                        Assign User</button>
                        <button
                            onClick={() => goToCreate()}
                            type="button" 
                            className="button secondary">
                        Create User</button>
                        </div>
                </div>

                {/* Stats Grid */}
                <div className="stats-grid">
                <div className="stats-container">
                    <StatCard 
                      title="Total Users" 
                      value={stats.total_users} 
                      icon={() => <Activity />}
                    />
                    <StatCard 
                      title="Active Users" 
                      value={stats.active_users} 
                      icon={() => <Drum />}
                    />
                    <StatCard 
                      title="Casual Users" 
                      value={stats.casual_users} 
                      icon={() => <BedDouble />}
                    />
                    <StatCard 
                      title="monthly users" 
                      value={stats.monthly_active_users} 
                      icon={() => <CalendarDays />}
                    />
                </div>
                </div>

                {/* Transactions Table */}
                <div className="transactions-section">
                  <div className="stats-header">
                      <h2 className="stats-title">Users</h2>
                      <select className="select-control">
                      <option>All</option>
                      </select>
                  </div>
                <Card>
                    <div className="tabs-header">
                    <div className="tabs">
                        {/* <button className="tab-button active">Deposits</button>
                        <button className="tab-button">Disbursements</button> */}
                    </div>
                    </div>
                    <div className="table-container">
                    <table>
                        <thead>
                        <tr>
                            <th>Email</th>
                            <th>Names</th>
                            <th>Role</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.map((user, idx) => (
                            <tr key={idx} className="table-row" onClick={() => goToItem(user.user_id)}>
                            <td>{user.email}</td>
                            <td>
                              <span className={`status-badge ${getStatusClass(user.last_name)}`}>
                                {user.last_name}
                              </span>
                              {user.first_name}
                            </td>
                            <td>
                            <span className={`status-badge ${getStatusClass(user.role)}`}>
                                {user.role}
                              </span>
                            </td>
                            <td>
                                {user.is_active ? <User/> : <UserMinus2/>}
                            </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                    {/* Pagination */}
                    <div className="pagination">
                    <div>
                        <p className="pagination-text">
                        Showing page {currentPage} of {Math.ceil(total / itemsPerPage)}
                        </p>
                    </div>
                    <div className="pagination-buttons">
                        <button
                        onClick={() => paginate(p => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        className="pagination-button"
                        >
                        <ChevronLeft className="icon" />
                        </button>
                        <button
                        onClick={() => paginate(p => p + 1)}
                        disabled={currentPage * itemsPerPage >= total}
                        className="pagination-button"
                        >
                        <ChevronRight className="icon" />
                        </button>
                    </div>
                    </div>
                </Card>
            </div>
        </div>
      }
    />
  );
};

export default UsersPage;
